import React, { useEffect } from 'react';
import ContentUploadContainer from './containers/ContentUploadContainer';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { posthog } from 'posthog-js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { PayloadProvider } from './AppPayloadContext';
import { body, colors } from './theme/theme';
import { FeatureFlagsProvider } from './services/featureFlags';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

function App() {
  const { isAuthenticated, loginWithRedirect, isLoading, user } = useAuth0();

  const chakraTheme = extendTheme({
    styles: {
      global: {
        body,
      },
    },
    colors: {
      colors,
    },
    components: {
      FormLabel: {
        baseStyle: {
          fontWeight: 'bold',
          fontSize: '20px',
          color: 'colors.tealBlack',
          marginBottom: '12px',
        },
      },
    },
  });

  useEffect(() => {
    if (user && window.ENV_CONFIG.keys.posthog_key) {
      posthog?.identify(user.email, {
        email: user.email,
        name: user.name,
      });
    }
  }, [user]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <FeatureFlagsProvider>
          <PayloadProvider>
            <ChakraProvider theme={chakraTheme}>
              <BrowserRouter>
                {!isAuthenticated && !isLoading ? (
                  loginWithRedirect()
                ) : (
                  <Routes>
                    <Route path="/" element={<ContentUploadContainer />} />
                  </Routes>
                )}
              </BrowserRouter>
            </ChakraProvider>
          </PayloadProvider>
        </FeatureFlagsProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
